import { useAuthStore } from "../store";

export function usePermission(key: string): boolean {
  return useAuthStore((s) => s.permissions.has(key));
}
